/* Japandi motion-laag: scroll-reveal met stagger.
   Principes: alleen opacity/transform, ease-out, eenmalig, reduced-motion gerespecteerd. */
(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (!('IntersectionObserver' in window)) return;

  var doelen = document.querySelectorAll(
    '.jp-sectie .jp-sec-kop, .jp-cat, .jp-prod, .jp-review, .jp-stap, .jp-usps > div, ' +
    '.jp-split > *, .jp-kasttype, .jp-cta .jp-wrap, .jp-formulier, .jp-kast-intro'
  );
  if (!doelen.length) return;

  var teller = {};
  doelen.forEach(function (el) {
    el.classList.add('jp-reveal');
    var ouder = el.parentElement;
    var key = ouder ? (ouder.className || 'x') : 'x';
    teller[key] = (teller[key] || 0);
    if (ouder && /jp-cats|jp-prods|jp-reviews|jp-stappen|jp-usps/.test(key)) {
      el.dataset.vertraging = String(Math.min(teller[key], 3));
      teller[key]++;
    }
  });

  var kijker = new IntersectionObserver(function (items) {
    items.forEach(function (item) {
      if (item.isIntersecting) {
        item.target.classList.add('is-zichtbaar');
        kijker.unobserve(item.target);
      }
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });

  doelen.forEach(function (el) { kijker.observe(el); });
})();
